<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader
        height="156"
        type="list-item-avatar-three-line"
        elevation="2"
        class="my-5"
        v-for="i in 5"
        :key="i"
      />
    </div>
    <div v-else>
      <LanguageSelector />
      <div v-if="!searchFail">
        <template v-for="(dateGroup, index) in timeSlots">
          <v-row :key="index">
            <v-col>
              <v-card outlined class="grey lighten-3">
                <v-card-text>
                  <v-row align="center">
                    <v-col cols="auto">
                      <time datetime="2014-09-20" class="icon">
                        <em class="blue--text">
                          {{ $d(Date.parse(dateGroup.date), "dayText") }}
                        </em>
                        <strong class="primary white--text">
                          {{ $d(Date.parse(dateGroup.date), "monthText") }}
                        </strong>
                        <span>
                          {{ $d(Date.parse(dateGroup.date), "dayShort") }}
                        </span>
                      </time>
                    </v-col>
                    <template v-for="range in dateGroup.rangeList">
                      <v-col :key="range.code" cols="auto">
                        <v-hover v-slot:default="{ hover }">
                          <v-card
                            :elevation="hover ? 12 : 2"
                            @click.native="
                              reserveSlot(Date.parse(dateGroup.date), range)
                            "
                          >
                            <v-card-text>
                              {{ range.dateFrom }} -
                              {{ range.dateTo }}
                            </v-card-text>
                          </v-card>
                        </v-hover>
                      </v-col>
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </div>
      <div v-else>
        {{ $t("timeSlot.notFound") }}
      </div>
    </div>
  </v-container>
</template>

<style src="./css/timeSlotReservation.css"></style>

<script>
import moment from "moment";
import { localhttp, trackinghttp } from "../http-commons";
import { hourToMinutes } from "@/js/utils.js";
import LanguageSelector from "@/components/LanguageSelector.vue";

const CONTEXT_TIME_SLOTS = "/public/timeSlots";
const CONTEXT_TIME_SLOTS_RESERVATIONS = "/public/timeSlotsReservations";
const CONTEXT_TRACKING_EXPEDITIONS = "/public/expeditions";

export default {
  name: "timeSlotReservation",
  components: {
    LanguageSelector
  },
  props: {
    token: {
      type: String,
      required: false
    },
    zipCode: {
      type: String,
      required: true
    },
    uuid: {
      type: String,
      required: false
    },
    lang: {
      type: String,
      required: false
    }
  },
  data: () => ({
    loading: true,
    searchFail: false,
    resourceNumberWeight: "",
    resourceNumberVolumen: "",
    resourceNumberSlots: "",
    organizationCode: "",
    countryReservation: "",
    postalCodeReservation: "",
    serviceReservation: "",
    tokenTracking: "",
    callback: "",
    scheludeToken: null,
    timeSlots: [],
    shippingNumber: null,
    shippingClient: null,
    shippingService: null,
    shippingDestinationPhone: null,
    reference: null,
    senderName: null,
    consigneeName: null
  }),
  methods: {
    async searchSlots() {
      this.loading = true;

      var deliveryOrderId,
        postalCode,
        date,
        volume,
        weight,
        service,
        organization,
        tokenTracking,
        client;

      //If token is in URL we have to make a GET call to tracking
      if (this.$props.token !== null && this.$props.zipCode !== null) {
        tokenTracking = this.$props.token;
        postalCode = this.$props.zipCode;
        var tokenMatch;
        try {
          // Validate token MD5
          let tokenRegex = new RegExp("^\\d{0,10}[A-Z]{4}");
          tokenMatch = tokenRegex.exec(tokenTracking).toString();
          var tokenMD5 = require("crypto")
            .createHash("md5")
            .update(tokenMatch.toString())
            .digest("hex");
          tokenMD5 = tokenMD5
            .substring(0, 16 - tokenMatch.length)
            .toUpperCase();
          tokenMatch = tokenMatch + tokenMD5;
        } catch (ex) {
          console.error(ex);
        }
        if (tokenMatch === tokenTracking) {
          this.tokenTracking = tokenTracking;
          await trackinghttp
            .get(
              CONTEXT_TRACKING_EXPEDITIONS +
                "/" +
                tokenTracking +
                "/" +
                postalCode
            )
            .then(response => {
              deliveryOrderId = response.data.deliveryOrderId;
              this.countryReservation =
                response.data.consignmentType === "PICKUP"
                  ? response.data.senderCountry
                  : response.data.consigneeCountry;
              this.postalCodeReservation =
                response.data.consignmentType === "PICKUP"
                  ? response.data.senderPostalCode
                  : response.data.consigneePostalCode;
              date = this.formatDate(response.data.requestedDeliveryDateFrom);
              volume = response.data.volume;
              weight = response.data.weight;
              service = response.data.serviceId;
              organization = response.data.organizationCode;
              client = response.data.senderCode;
              this.scheludeToken = response.data.scheludeToken;
              this.shippingNumber = response.data.deliveryOrderId;
              this.shippingClient = response.data.senderCode;
              this.shippingService =
                response.data.additionalServices.length == 0
                  ? null
                  : response.data.additionalServices[0].name;
              this.shippingDestinationPhone = response.data.consigneeTelephone;
              this.reference = response.data.reference1;
              this.senderName = response.data.senderName;
              this.consigneeName = response.data.consigneeName;
            })
            .catch(e => {
              console.log(e);
              this.$showError();
              this.searchFail = true;
            });
        } else {
          this.searchFail = true;
        }
      } else {
        // If token not present is a query URL
        this.searchFail = true;
      }
      if (!this.searchFail) {
        this.serviceReservation = service;
        await localhttp
          .post(CONTEXT_TIME_SLOTS + "/avalible", {
            deliveryOrderId: deliveryOrderId,
            country: this.countryReservation,
            postalCode: this.postalCodeReservation,
            date: date,
            volume: volume,
            weight: weight,
            client: client,
            service: this.serviceReservation,
            organizationCode: organization
          })
          .then(response => {
            if (response.data.length > 0) {
              this.timeSlots = response.data;
              this.resourceNumberSlots = null;
              this.resourceNumberWeight = weight;
              this.resourceNumberVolumen = volume;
            } else {
              this.searchFail = true;
            }
          })
          .catch(e => {
            console.log(e);
            this.$showError();
            this.searchFail = true;
          });
      }
      this.loading = false;
    },
    async reserveSlot(dateSelected, timeSlotSelected) {
      if (
        await this.$root.$confirm(
          this.$t("global.confirm"),
          this.$t("bookTimeSlot.confirm"),
          {
            color: "blue"
          }
        )
      ) {
        this.$root.$loading();
        let method = "/createWeb";
        if (this.scheludeToken !== undefined && this.scheludeToken !== null) {
          method = "/reschelude/" + this.scheludeToken;
        }

        let minutesFrom = hourToMinutes(timeSlotSelected.dateFrom);
        let minutesTo = hourToMinutes(timeSlotSelected.dateTo);

        //Create reservation and get token
        await localhttp
          .post(CONTEXT_TIME_SLOTS_RESERVATIONS + method, {
            resourceNumberSlots: this.resourceNumberSlots,
            resourceNumberWeight: this.resourceNumberWeight,
            resourceNumberVolumen: this.resourceNumberVolumen,
            date: dateSelected,
            hourFrom: minutesFrom,
            hourTo: minutesTo,
            timeSlotCode: timeSlotSelected.code,
            countryReservation: this.countryReservation,
            postalCodeReservation: this.postalCodeReservation,
            serviceReservation: this.serviceReservation,
            tokenTracking: this.tokenTracking,
            uuid: this.$props.uuid,
            shippingNumber: this.shippingNumber,
            shippingClient: this.shippingClient,
            shippingService: this.shippingService,
            shippingDestinationPhone: this.shippingDestinationPhone,
            reference: this.reference,
            senderName: this.senderName,
            consigneeName: this.consigneeName
          })
          .then(response => {
            this.$root.$loaded();
            console.debug(response.data.token);
            //Save reservation token and redirect
            window.location.href = this.callback;
          })
          .catch(e => {
            console.log(e);
            this.searchSlots();
            this.$root.$loaded();
            this.$showErrorCode(e.response.status);
          });
      }
    },
    formatDate(dateISO) {
      return moment(dateISO).format("YYYY-MM-DD");
    }
  },
  mounted() {
    if (document.referrer != "") {
      this.callback = new URL(document.referrer);

      if (this.$props.lang != null) {
        this.$i18n.locale = this.$props.lang;

        if (!this.callback.searchParams.has("lang")) {
          this.callback.searchParams.append("lang", this.$props.lang);
        } else {
          this.callback.searchParams.set("lang", this.$props.lang);
        }
      }
    }
    this.searchSlots();
  }
};
</script>
